import React, { useState } from "react";
import { Search, ChevronUp, ChevronDown } from "lucide-react";
import "./Order.css";

export default function Order() {
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "date", direction: "asc" });

  const [orders] = useState([
    { id: 1, date: "2025-01-12", name: "Gaming PC", qty: 1, customer: "C102", status: "Pending" },
    { id: 2, date: "2025-01-10", name: "Office PC", qty: 2, customer: "C088", status: "Shipped" },
    { id: 3, date: "2025-01-18", name: "Editing PC", qty: 1, customer: "C143", status: "Pending" },
  ]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key, direction });
  };

  const sortedOrders = [...orders].sort((a, b) => {
    let aVal = a[sortConfig.key];
    let bVal = b[sortConfig.key];

    if (typeof aVal === "string") aVal = aVal.toLowerCase();
    if (typeof bVal === "string") bVal = bVal.toLowerCase();

    if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const filtered = sortedOrders.filter((o) =>
    Object.values(o).some((v) => String(v).toLowerCase().includes(search.toLowerCase()))
  );

  const SortIcons = ({ columnKey }) => {
    const isActive = sortConfig.key === columnKey;
    return (
      <span style={{ display: "inline-flex", flexDirection: "column", marginLeft: 5 }}>
        <ChevronUp size={12} color={isActive && sortConfig.direction === "asc" ? "#568ddf" : "#ccc"} />
        <ChevronDown size={12} color={isActive && sortConfig.direction === "desc" ? "#568ddf" : "#ccc"} />
      </span>
    );
  };

  return (
    <div className="adorder-container">

      <h2 className="adorder-title">Order List</h2>
<div className="adorder-widgets">
  <div className="adorder-widget">
    <div className="widget-header">
      <div className="widget-icon">📦</div>
      <h3>Today Orders</h3>
    </div>
    <p className="widget-value">32</p>
    <span className="widget-change">+5% from yesterday</span>
  </div>

  <div className="adorder-widget">
    <div className="widget-header">
      <div className="widget-icon">✅</div>
      <h3>Completed Orders</h3>
    </div>
    <p className="widget-value">128</p>
    <span className="widget-change">+12% from yesterday</span>
  </div>

  <div className="adorder-widget">
    <div className="widget-header">
      <div className="widget-icon">⏳</div>
      <h3>Pending Orders</h3>
    </div>
    <p className="widget-value">14</p>
    <span className="widget-change">-3% from yesterday</span>
  </div>
</div>



      <div className="adorder-top-bar">
        <div className="adorder-search-box">
          <Search size={20} />
          <input
            type="text"
            placeholder="Search orders..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="adorder-table-container">
        <table className="adorder-table">
          <thead>
            <tr>
              <th onClick={() => handleSort("date")} style={{ cursor: "pointer" }}>
                Date <SortIcons columnKey="date" />
              </th>
              <th onClick={() => handleSort("name")} style={{ cursor: "pointer" }}>
                PC Name <SortIcons columnKey="name" />
              </th>
              <th onClick={() => handleSort("qty")} style={{ cursor: "pointer" }}>
                Qty <SortIcons columnKey="qty" />
              </th>
              <th onClick={() => handleSort("customer")} style={{ cursor: "pointer" }}>
                Customer ID <SortIcons columnKey="customer" />
              </th>
              <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                Status <SortIcons columnKey="status" />
              </th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((o) => (
              <tr key={o.id}>
                <td>{o.date}</td>
                <td>{o.name}</td>
                <td>{o.qty}</td>
                <td>{o.customer}</td>
                <td>
                  <span className={o.status === "Shipped" ? "adorder-shipped" : "adorder-pending"}>
                    {o.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}